import {
  WORK_ORDER_CATEGORY_LABELS,
  WORK_ORDER_STATUS_LABELS,
  type WorkOrderSeverity,
  type WorkOrderStatus,
} from '@sitewise/shared';
import { StatPill } from '@sitewise/ui';

const STATUS_TONE: Record<WorkOrderStatus, Parameters<typeof StatPill>[0]['tone']> = {
  submitted: 'info',
  triaged: 'primary',
  in_progress: 'primary',
  awaiting_vendor: 'warning',
  awaiting_parts: 'warning',
  on_hold: 'warning',
  completed: 'success',
  cancelled: 'neutral',
};

export function StatusPill({ status }: { status: WorkOrderStatus }) {
  return (
    <StatPill
      value={WORK_ORDER_STATUS_LABELS[status]}
      tone={STATUS_TONE[status]}
      withDot
    />
  );
}

export function categoryLabel(category: string): string {
  return WORK_ORDER_CATEGORY_LABELS[category as keyof typeof WORK_ORDER_CATEGORY_LABELS] ?? category;
}

export function severityToken(severity: WorkOrderSeverity) {
  return severity;
}

export function relativeTime(iso: string): string {
  const t = new Date(iso).getTime();
  const now = Date.now();
  const diff = Math.round((now - t) / 1000);
  if (diff < 60) return 'just now';
  if (diff < 3_600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86_400) return `${Math.floor(diff / 3_600)}h ago`;
  if (diff < 30 * 86_400) return `${Math.floor(diff / 86_400)}d ago`;
  return new Date(iso).toLocaleDateString();
}

export function formatDateTime(iso: string | null): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString();
}

export function isOverdue(dueAt: string | null, status: WorkOrderStatus): boolean {
  if (!dueAt) return false;
  if (status === 'completed' || status === 'cancelled') return false;
  return new Date(dueAt).getTime() < Date.now();
}
